import React, { useEffect } from 'react'

import './ScrollView.css'
import ScrollViewListTemplate from './templates/ScrollViewListTemplate'

function ScrollView({items, type, proffer}) {
    
    function findPlayer(homeTeamId, awayTeamId, proffer) {
        const players = proffer?.filter((player) => {
            return (
                player.team_id === homeTeamId || player.team_id === awayTeamId
            )
        })
        return players
    }

    return (
        <React.Fragment>
            <div className="scrollGrid">
                <div className="scrollMenu">
                {items?.map((item, index) => {
                    const playersFixture = findPlayer(
                        item.homeTeam.team_id,
                        item.awayTeam.team_id,
                        proffer
                    )
                    return <ScrollViewListTemplate key={index} item={item} type={type} playersFixture={playersFixture} />
                })}

                </div>
            </div>
        </React.Fragment>
    )
}
export default ScrollView